import $ from 'jquery';

$(function(){
  $("#toggle-search").click(function(){
    $('.search-toggle').toggleClass('open');
    $('.search-toggle input').focus();
  });
});
